

const Footer = () => {
    return (
        <footer>
            <h4>Created by Philip Miles @ Juno College</h4>
        </footer>
    )
}

export default Footer;